module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/dir_off-a46062adc1681fe2f2efb0a6ae3fb648.gif";